import React, { useContext, useRef, useState } from 'react';
import { SearchBox, List } from 'office-ui-fabric-react';

import { AddressesResponse, AddressItem, Props } from './MapPage.types';
import { Styled } from './MapPage.styles';

import axios from 'utils/axios';
import { throttle } from 'utils/delay';
import { mapContext } from './mapContext';
import { useMapHelpers } from '../../../../hooks/useMapHelpers';

export const AddressSearch: React.FC = () => {
  const [searchActive, setSearchActive] = useState(false);
  const [addresses, setAddresses] = useState<AddressItem[]>([]);
  const { mapRef } = useContext(mapContext);
  const { centerMap } = useMapHelpers(mapRef);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const onSearch = useRef(
    throttle(async (value?: string) => {
      if (value) {
        const encoded = encodeURI(`Санкт-Петербург ${value}`);
        const { data } = await axios.get<AddressesResponse>(
          `search?q=${encoded}&format=json&addressdetails=1&limit=5&countrycodes=ru`
        );
        setAddresses(
          data.map(({ display_name, lat, lon }) => ({
            coordinates: [parseFloat(lat), parseFloat(lon)],
            name: display_name,
          }))
        );
      }
    }, 1000)
  );

  const onRenderAddressCell = (item?: AddressItem) => {
    if (!item) return null;
    return (
      <Styled.AddressItem
        onClick={() => {
          centerMap(item.coordinates);
          setSearchActive(false);
        }}
      >
        {item.name}
      </Styled.AddressItem>
    );
  };

  return (
    <Styled.SearchWrapper
      open={searchActive}
      ref={wrapperRef}
      onClick={(event) => {
        if (event.target === wrapperRef.current) {
          setSearchActive(false);
        }
      }}
    >
      <SearchBox
        placeholder="Поиск по адресу"
        onChange={onSearch.current}
        onClick={() => setSearchActive(true)}
      />
      <List<AddressItem> items={addresses} onRenderCell={onRenderAddressCell} />
    </Styled.SearchWrapper>
  );
};
